import { Injectable, Injector } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { ToastService } from '../services/toast.service';
import { TranslateCommonService } from '@core/services/translate.service';

@Injectable({ providedIn: 'root' })
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private injector: Injector) {}

    private get toastService(): ToastService {
        return this.injector.get(ToastService);
    }

    private get translateService(): TranslateCommonService {
        return this.injector.get(TranslateCommonService);
    }

    public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError((err) => {
                console.log('ErrorInterceptor', err);
                if (err instanceof HttpErrorResponse) {
                    switch (err.status) {
                        case 401:
                            return throwError(() => err);
                        case 500:
                            return this.toastService
                                .openToast(this.translateService.instant(`errors.backends-codes.base`), 'danger')
                                .pipe(switchMap(() => throwError(() => err)));
                        default:
                            const beCode = err?.error?.code || err?.error?.errorCode || err?.error?.ErrorCode || '';
                            if (beCode) {
                                const translateKey = `errors.backends-codes.${beCode}`;
                                const hasTranslate = this.translateService.hasTranslation(translateKey);
                                if (hasTranslate) {
                                    return this.toastService
                                        .openToast(this.translateService.instant(translateKey), 'danger')
                                        .pipe(switchMap(() => throwError(() => err)));
                                }
                            }

                            if (err?.error?.message) {
                                // @ts-ignore
                                return this.toastService
                                    .openToast(`${err.error?.message}`, 'danger')
                                    .pipe(switchMap(() => throwError(() => err)));
                            }

                            if (err.error?.errorText && err.error?.errorText[0]) {
                                // @ts-ignore
                                return this.toastService
                                    .openToast(`${err.error?.errorText[0]}`, 'danger')
                                    .pipe(switchMap(() => throwError(() => err)));
                            }

                            if (err.error?.ErrorText) {
                                return this.toastService
                                    .openToast(`${err.error?.ErrorText}`, 'danger')
                                    .pipe(switchMap(() => throwError(() => err)));
                            }

                            if (!err.error?.ErrorText && err.error?.error) {
                                return this.toastService
                                    .openToast(`${err.error?.error}`, 'danger')
                                    .pipe(switchMap(() => throwError(() => err)));
                            }

                            return throwError(() => err);
                    }
                }

                return throwError(() => err);
            }),
        );
    }
}
